import { connect } from 'react-redux'
import TestDriveModal from './TestDriveModal'
import { close } from '../../state/test-drive-modal/actions'

const mapDispatchToProps = (dispatch) => ({
  onClose: () => dispatch(close())
})

export default connect(
  (state) => state.testDriveModal,
  mapDispatchToProps
)(TestDriveModal)
